import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import GoogleTranslate from '../language/GoogleTranslate';

import support_icon1 from '../../assets/support-icon1.svg';
import support_icon2 from '../../assets/support-icon2.svg';
import support_icon3 from '../../assets/support-icon3.svg';
import support_icon4 from '../../assets/support-icon4.svg';

interface Settings {
  pushNotifications: boolean;
  checkInTime: string;
  language: string;
}

const Setting: React.FC = () => {
  const { user } = useAuth();
  const [settings, setSettings] = useState<Settings>({
    pushNotifications: true,
    checkInTime: '09:00',
    language: '한국어',
  });

  useEffect(() => {
    try {
      const fetchUser = async () => {
        const response = await axios.get('/api/users/get', { params: user });
      };
      fetchUser();
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleToggleNotification = () => {
    setSettings(prev => ({
      ...prev,
      pushNotifications: !prev.pushNotifications,
    }));
  };

  return (
    <div className="main-container">
      <div className="app-container setting-container">
        {/* 알림 & 개인화 */}
        <section className="setting-section">
          <div className="section-header">
            <h2>알림 & 개인화</h2>
          </div>
          <div className="setting-item">
            <div className="setting-label">
              <span>푸시 알림</span>
              <p>앱 알림을 받으려면 켜주세요</p>
            </div>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={settings.pushNotifications}
                onChange={handleToggleNotification}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          {/* 알림이 켜져있을 때만 체크인 시간 설정 가능 */}
          {settings.pushNotifications && (
            <div className="setting-item">
              <div className="setting-label">
                <span>체크인 시간</span>
                <p>매일 체크인 알림을 받을 시간</p>
              </div>
              <input
                type="time"
                value={settings.checkInTime}
                onChange={e => setSettings(prev => ({ ...prev, checkInTime: e.target.value }))}
                className="time-input"
              />
            </div>
          )}

          <div className="setting-item">
            <div className="setting-label">
              <span>언어</span>
              <p>앱에서 사용할 언어를 선택하세요</p>
            </div>
            {/* <select
            value={settings.language}
            onChange={e => setSettings(prev => ({ ...prev, language: e.target.value }))}
            className="language-select"
          >
            <option value="한국어">한국어</option>
            <option value="English">English</option>
            <option value="日本語">日本語</option>
          </select> */}
            <GoogleTranslate />
          </div>
        </section>

        {/* 고객센터 */}
        <section className="setting-section">
          <div className="section-header">
            <h2>고객센터</h2>
          </div>
          <div className="support-menu">
            <Link to="/setting/qna/new" style={{ textDecoration: 'none' }}>
              <div className="support-item">
                <div className="support-icon">
                  <img src={support_icon1} alt="" />
                </div>
                <div className="support-content">
                  <h4>1:1 문의</h4>
                  <p>궁금한 점을 문의하세요</p>
                </div>
                <span className="arrow">›</span>
              </div>
            </Link>

            <Link to="/setting/qna-list" style={{ textDecoration: 'none' }}>
              <div className="support-item">
                <div className="support-icon">
                  <img src={support_icon2} alt="" />
                </div>
                <div className="support-content">
                  <h4>문의 내역</h4>
                  <p>이전 문의사항을 확인하세요</p>
                </div>
                <span className="arrow">›</span>
              </div>
            </Link>

            <Link to="/setting/notice" style={{ textDecoration: 'none' }}>
              <div className="support-item">
                <div className="support-icon">
                  <img src={support_icon3} alt="" />
                </div>
                <div className="support-content">
                  <h4>공지사항</h4>
                  <p>최신 소식을 확인하세요</p>
                </div>
                <span className="arrow">›</span>
              </div>
            </Link>

            <Link to="/setting/faq-list" style={{ textDecoration: 'none' }}>
              <div className="support-item">
                <div className="support-icon">
                  <img src={support_icon4} alt="" />
                </div>
                <div className="support-content">
                  <h4>자주 묻는 질문</h4>
                  <p>FAQ를 확인하세요</p>
                </div>
                <span className="arrow">›</span>
              </div>
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Setting;
